import React, { useEffect, useState } from "react";
import Header from "../components/Header";
import axios from "axios";

import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import InputLabel from '@mui/material/InputLabel';
import Box from '@mui/material/Box';
import Typography from '@mui/material/Typography';
import FormControl from '@mui/material/FormControl';
import FormControlLabel from '@mui/material/FormControlLabel';
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Link } from '@mui/material';
import IconButton from '@mui/material/IconButton';
import DiamondIcon from '@mui/icons-material/Diamond';
import OutlinedInput from '@mui/material/OutlinedInput';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import InputAdornment from '@mui/material/InputAdornment';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import { useNavigate } from "react-router-dom";
import GppGoodIcon from '@mui/icons-material/GppGood';
import { MascaraCpf } from "../../utils/MascaraCpf";
import { TirarMascara } from "../../utils/TirarMascara";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";
import { MascaraCep } from "../../utils/MascaraCep";
import { MascaraTelefone } from "../../utils/MascaraTelefone";
import AlertSuccess from "../components/AlertSuccess";
import AlertError from "../components/AlertError";
import Loading from "../components/Loading";
import { useLogin } from "../../contexts/LoginContext";
import { CapitalizeWords } from "../../utils/CapitalizeWords";
import { FormatToBrl } from "../../utils/FormatToBrl";
import { Tooltip } from "@mui/material";
import ValidadorCpf from "../../utils/ValidadorCpf";
import { gerarLinkWhatsApp } from "../../utils/WhatsappLink";
import {
    Checkbox,
} from "@mui/material";

const steps = [
    { number: 1, label: "Informações Pessoais" },
    { number: 2, label: "Confirmar E-mail" },
    { number: 3, label: "Definir Senha" },
    { number: 4, label: "Checkout" },
];


const Register = () => {

    const navigate = useNavigate();
    const { fetchLogin } = useLogin();

    const [isMobile, setIsMobile] = useState(false);
    const [currentStep, setCurrentStep] = useState(1);

    const [nome, setNome] = useState("");
    const [nomeError, setNomeError] = useState(false);

    const [typePerson, setTypePerson] = useState("pessoaFisica");

    const [cpf, setCpf] = useState("");
    const [cpfError, setCpfError] = useState(false);

    const [cnpj, setCnpj] = useState("");

    const [razaoSocial, setRazaoSocial] = useState("");
    const [razaoSocialError, setRazaoSocialError] = useState(false);

    const [cep, setCep] = useState("");
    const [cepError, setCepError] = useState(false);

    const [estado, setEstado] = useState("");
    const [cidade, setCidade] = useState("");
    const [bairro, setBairro] = useState("");
    const [logradouro, setLogradouro] = useState("");
    const [numero, setNumero] = useState("");
    const [numeroError, setNumeroError] = useState(false);

    const [complemento, setComplemento] = useState("");

    const [telefone, setTelefone] = useState("");
    const [telefoneError, setTelefoneError] = useState(false);

    const [email, setEmail] = useState("");
    const [emailError, setEmailError] = useState(false);

    const [senha, setSenha] = useState("");
    const [senhaError, setSenhaError] = useState(false);

    const [senhaConfirm, setSenhaConfirm] = useState("");
    const [senhaConfirmError, setSenhaConfirmError] = useState(false);

    const [agreeContractService, setAgreeContractService] = useState(false);
    const [agreeConditions, setAgreeConditions] = useState(false);

    const [emailVerified, setEmailVerified] = useState(false);
    const [timer, setTimer] = useState(60);
    const [canResend, setCanResend] = useState(false);

    const [codigo, setCodigo] = useState("");

    const [openSnackbarSuccess, setOpenSnackbarSuccess] = useState(false);
    const [openSnackbarError, setOpenSnackbarError] = useState(false);
    const [mensagem, setMensagem] = useState("");
    const [leadId, setLeadId] = useState(null);

    const [open, setOpen] = useState(false);

    const token = localStorage.getItem("token");

    const hasChosenPlan = localStorage.getItem("planoSelecionado");

    useEffect(() => {
        if (!hasChosenPlan) {
            navigate("../planos");
        }
    }, [hasChosenPlan, navigate]);

    useEffect(() => {
        if (timer <= 0) {
            setCanResend(true);
            return;
        }

        const interval = setInterval(() => {
            setTimer((prev) => prev - 1);
        }, 1000);

        return () => clearInterval(interval);
    }, [timer]);

    useEffect(() => {
        window.scrollTo(0, 0);
    }, []);

    useEffect(() => {
        if (token) {
            // Se o token existir, redireciona para a página inicial
            navigate("../checkout");
        }
    }, [token, navigate]);

    // Detectar se é mobile (tela menor que 768px)
    useEffect(() => {
        const handleResize = () => {
            setIsMobile(window.innerWidth <= 768);
        };

        handleResize(); // chama ao carregar
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    const [showPassword, setShowPassword] = useState(false);

    const handleClickShowPassword = () => setShowPassword((show) => !show);

    const handleMouseDownPassword = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPassword = (event) => {
        event.preventDefault();
    };

    const [showPasswordConfirm, setShowPasswordConfirm] = useState(false);

    const handleClickShowPasswordConfirm = () => setShowPasswordConfirm((show) => !show);

    const handleMouseDownPasswordConfirm = (event) => {
        event.preventDefault();
    };

    const handleMouseUpPasswordConfirm = (event) => {
        event.preventDefault();
    };

    const salvarLead = async (stepAtual) => {
        if (!nome && !email && !telefone) return;

        setOpen(true);

        try {
            const payload = {
                idLead: leadId || null,
                nome,
                telefone: TirarMascara(telefone),
                email,
                razaoSocial,
                stepAtual,
                ...(cpf && { cpf: TirarMascara(cpf) }),
                ...(cnpj && { cnpj: TirarMascara(cnpj) }),
            };

            const { data } = await axios.post(
                `${process.env.REACT_APP_API_URL}/salvarLead`,
                payload
            );

            if (data.lead?.idLead) {
                setLeadId((prev) => prev || data.lead.idLead);
            }

        } catch (err) {
            console.error("Erro ao salvar lead:", err);
        } finally {
            setOpen(false);
        }
    };


    const HandleGetAddress = (CEP) => {
        setCep(MascaraCep(CEP));
        console.log("Buscando endereço para o CEP:", CEP);
        if (CEP.length === 9) {
            setOpen(true);
            axios.get(`https://viacep.com.br/ws/${TirarMascara(CEP)}/json/`)
                .then(response => {
                    const { data } = response;
                    setEstado(data.estado);
                    setCidade(data.localidade);
                    setBairro(data.bairro);
                    setLogradouro(data.logradouro);
                    console.log("Endereço encontrado:", data);
                    if (data.erro === 'true') {
                        setCepError(true);
                        setMensagem("CEP inválido. Tente novamente.");
                        setOpenSnackbarError(true);
                    } else {
                        setCepError(false);
                    }
                    setOpen(false);
                })
                .catch(error => {
                    setOpen(false);
                    console.error("Erro ao buscar o endereço:", error);
                });
        }
    }

    const HandleSendEmailVerification = async (email) => {
        setOpen(true);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/enviarEmail`,
                {
                    email: email.trim().toLowerCase()
                }
            );

            console.log("Resposta enviar código:", response);

            const status = Number(response.data.status);

            // ============================================
            // CÓDIGO ENVIADO
            // ============================================

            if (status === 200) {
                setOpen(false);

                setOpenSnackbarSuccess(true);
                setCanResend(false);
                setTimer(60);

                setMensagem(
                    "Código de verificação enviado com sucesso!"
                );

                return response;
            }

            // ============================================
            // E-MAIL JÁ CADASTRADO
            // ============================================

            if (status === 400) {
                setOpen(false);

                setEmailError(true);
                setOpenSnackbarError(true);

                setMensagem(
                    response.data.mensagem ||
                    "E-mail já cadastrado. Tente outro."
                );

                return response;
            }

            // ============================================
            // ERRO
            // ============================================

            if (status === 500) {
                setOpen(false);

                setEmailError(true);
                setOpenSnackbarError(true);

                setMensagem(
                    response.data.mensagem ||
                    "E-mail inválido. Tente novamente."
                );

                return response;
            }

            // ============================================
            // STATUS DESCONHECIDO
            // ============================================

            setOpen(false);

            setOpenSnackbarError(true);
            setMensagem(
                "Não foi possível enviar o código de verificação."
            );

            return response;

        } catch (error) {
            console.error(
                "Erro ao enviar código de verificação:",
                error
            );

            setOpen(false);

            setEmailError(true);
            setOpenSnackbarError(true);

            setMensagem(
                error.response?.data?.mensagem ||
                "Não foi possível enviar o código de verificação."
            );

            return error.response || null;
        }
    };

    const HandleValidateEmailCode = async (email, codigo) => {
        setOpen(true);

        console.log("Validando código de verificação:", codigo);

        try {
            const response = await axios.post(
                `${process.env.REACT_APP_API_URL}/confirmarConta`,
                {
                    email,
                    codigo
                }
            );

            console.log("Resposta confirmação:", response);

            if (response.data.status === 200) {

                // ============================================
                // E-MAIL CONFIRMADO
                // ============================================

                // Atualiza o Lead depois da confirmação
                await salvarLead(currentStep);

                setEmailVerified(true);

                setCurrentStep((prev) => Math.min(prev + 1, 5));

                setOpenSnackbarSuccess(true);
                setMensagem("E-mail verificado com sucesso!");

                setOpen(false);

                return;
            }

            // ============================================
            // CÓDIGO INVÁLIDO
            // ============================================

            setOpen(false);

            setOpenSnackbarError(true);
            setMensagem(
                response.data.mensagem ||
                "Código de verificação inválido."
            );

        } catch (error) {
            setOpen(false);

            console.error(
                "Erro ao validar código de verificação:",
                error
            );

            setOpenSnackbarError(true);
            setMensagem(
                "Não foi possível validar o código. Tente novamente."
            );
        }
    };

    const planoSelected = localStorage.getItem("planoSelecionado") ? JSON.parse(localStorage.getItem("planoSelecionado")) : false;


    const stepOne = () => {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    gap: 2,
                    pt: 5,
                    px: 1,
                }}
            >
                {/* Primeira linha */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <TextField
                        label="Nome Completo"
                        variant="outlined"
                        size="small"
                        value={CapitalizeWords(nome)}
                        onChange={(e) => setNome(e.target.value)}
                        error={nomeError}
                        helperText={nomeError ? "Nome é obrigatório" : ""}
                        required
                        sx={{
                            flex: { xs: "1 1 100%", md: "1 1 60%" },
                        }}
                    />
                    <TextField
                        label="Telefone (WhatsApp)"
                        variant="outlined"
                        size="small"
                        value={telefone}
                        onChange={(e) =>
                            setTelefone(MascaraTelefone(e.target.value))
                        }
                        placeholder="(00) 00000-0000"
                        error={telefoneError}
                        helperText={telefoneError ? "Telefone é obrigatório" : ""}
                        required
                        sx={{
                            flex: { xs: "1 1 100%", md: "1 1 calc(40% - 16px)" },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip
                                        arrow
                                        placement="top"
                                        title="Pedimos seu telefone para agilizar o contato caso precisemos falar com você."
                                    >
                                        <IconButton edge="end" size="small">
                                            <InfoOutlinedIcon fontSize="small" color="action" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>

                {/* Segunda linha */}
                <Box
                    sx={{
                        display: "flex",
                        gap: 2,
                        flexWrap: "wrap",
                    }}
                >
                    <TextField
                        label="CPF"
                        variant="outlined"
                        size="small"
                        value={cpf}
                        onChange={(e) => setCpf(MascaraCpf(e.target.value))}
                        error={cpfError}
                        helperText={cpfError ? "CPF é obrigatório" : ""}
                        required
                        sx={{
                            flex: 1,
                            minWidth: { xs: "100%", md: 250 },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip
                                        arrow
                                        placement="top"
                                        title="Usamos seu CPF apenas para validar cadastro e contrato. Seus dados são protegidos conforme a LGPD."
                                    >
                                        <IconButton edge="end" size="small">
                                            <InfoOutlinedIcon fontSize="small" color="action" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />

                    <TextField
                        label="E-mail"
                        type="email"
                        variant="outlined"
                        size="small"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        error={emailError}
                        helperText={emailError ? "E-mail é obrigatório" : ""}
                        required
                        sx={{
                            flex: 1,
                            minWidth: { xs: "100%", md: 250 },
                        }}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <Tooltip
                                        arrow
                                        placement="top"
                                        title="Precisamos do seu e-mail para criar o seu acesso à plataforma Contblack."
                                    >
                                        <IconButton edge="end" size="small">
                                            <InfoOutlinedIcon fontSize="small" color="action" />
                                        </IconButton>
                                    </Tooltip>
                                </InputAdornment>
                            ),
                        }}
                    />
                </Box>
            </Box>
        )
    }

    const StepTwo = () => {
        return (
            <Box
                sx={{
                    width: "100%",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    pt: 5,
                    px: 2,
                }}
            >

                <Typography
                    sx={{
                        color: "#666",
                        textAlign: "center",
                        mb: 4,
                        maxWidth: 500,
                    }}
                >
                    Enviamos um código de verificação para
                    <strong> {email}</strong>. Digite-o abaixo para continuar.
                </Typography>

                <TextField
                    label="Código de verificação"
                    placeholder="000000"
                    value={codigo}
                    onChange={(e) => setCodigo(e.target.value)}
                    inputProps={{
                        maxLength: 6,
                        style: {
                            textAlign: "center",
                            fontSize: "1.5rem",
                            letterSpacing: "8px",
                        },
                    }}
                    sx={{
                        width: {
                            xs: "100%",
                            sm: 320,
                        },
                    }}
                />

                <Button
                    variant="contained"
                    sx={{
                        padding: "10px 28px",
                        width: "200px",
                        mt: 3,
                        backgroundColor: "#9C01B9",
                        borderRadius: "17px 0 17px 0",
                        fontSize: "0.7rem",
                        color: "white",
                        fontWeight: 800,
                        transition: "0.3s ease",
                        '&:hover': {
                            backgroundColor: "#1EFF86",
                            boxShadow: "0 4px 10px #1EFF86",

                        }
                    }}
                    onClick={() => HandleValidateEmailCode(email, codigo)}
                >
                    Validar código
                </Button>

                <Typography
                    sx={{
                        mt: 3,
                        fontSize: ".9rem",
                        color: "#666",
                        textAlign: "center",
                        userSelect: "none"
                    }}
                >
                    Não recebeu o código?{" "}
                    <Typography
                        component="span"
                        sx={{
                            color: canResend ? "primary.main" : "#666",
                            fontWeight: 600,
                            cursor: "pointer",
                        }}
                        onClick={() => canResend && HandleSendEmailVerification(email)}

                    >
                        {canResend
                            ? "Reenviar código"
                            : `Reenviar em ${timer}s`}
                    </Typography>
                </Typography>
            </Box >
        );
    };
    // const stepThree = () => {
    //     return (
    //         <div style={{ width: "100%" }}>
    //             <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", flexDirection: "column", alignContent: "center", padding: "50px 10px 10px" }}>
    //                 <p variant="h6" align="center" style={{ marginBottom: "20px" }}>
    //                     Foi enviado um código de verificação para o e-mail: <strong>{email}</strong>. Verifique a caixa de entrada e o spam do e-mail e insira o código abaixo para continuar.
    //                 </p>
    //                 <TextField
    //                     label="Código"
    //                     inputProps={{ maxLength: 6 }}
    //                     variant="outlined"
    //                     size="small"
    //                     required
    //                     value={codigo}
    //                     onChange={(e) => setCodigo(e.target.value)}
    //                     sx={{
    //                         width: isMobile ? "100%" : "40%",
    //                         marginBottom: "20px",
    //                         "& input": {
    //                             letterSpacing: "10px",
    //                             fontSize: "22px",
    //                             textAlign: "center",
    //                         }
    //                     }}
    //                 />
    //                 <Button onClick={() => HandleValidateEmailCode(email, codigo)}
    //                     sx={{
    //                         padding: "5px 28px",
    //                         backgroundColor: "#9C01B9",
    //                         borderRadius: "17px 0 17px 0",
    //                         fontSize: "0.7rem",
    //                         color: "white",
    //                         fontWeight: 800,
    //                         transition: "0.3s ease",
    //                         '&:hover': {
    //                             backgroundColor: "#1EFF86",
    //                             boxShadow: "0 4px 10px #1EFF86",

    //                         }
    //                     }}>
    //                     Validar código
    //                 </Button>
    //             </div>
    //         </div>
    //     )
    // }

    const stepThree = () => {
        return (
            <div style={{ width: "100%" }}>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", padding: "50px 10px 10px" }}>
                    <FormControl fullWidth size="small" variant="outlined">
                        <InputLabel>Senha</InputLabel>
                        <OutlinedInput
                            error={senhaError}
                            required
                            type={showPassword ? 'text' : 'password'}
                            onChange={(e) => setSenha(e.target.value)}
                            value={senha}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showPassword ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowPassword}
                                        onMouseDown={handleMouseDownPassword}
                                        onMouseUp={handleMouseUpPassword}
                                        edge="end"
                                    >
                                        {showPassword ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Senha"
                        />
                    </FormControl>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", alignItems: "center", padding: "10px 10px 10px" }}>
                    <FormControl fullWidth size="small" variant="outlined">
                        <InputLabel>Confirmar Senha</InputLabel>
                        <OutlinedInput
                            error={senhaConfirmError}
                            required
                            type={showPasswordConfirm ? 'text' : 'password'}
                            onChange={(e) => setSenhaConfirm(e.target.value)}
                            value={senhaConfirm}
                            endAdornment={
                                <InputAdornment position="end">
                                    <IconButton
                                        aria-label={
                                            showPasswordConfirm ? 'hide the password' : 'display the password'
                                        }
                                        onClick={handleClickShowPasswordConfirm}
                                        onMouseDown={handleMouseDownPasswordConfirm}
                                        onMouseUp={handleMouseUpPasswordConfirm}
                                        edge="end"
                                    >
                                        {showPasswordConfirm ? <VisibilityOff /> : <Visibility />}
                                    </IconButton>
                                </InputAdornment>
                            }
                            label="Confirmar Senha"
                        />
                    </FormControl>
                </div>
                <Box sx={{ width: "100%", p: 0, }} >
                    <FormControlLabel sx={{ alignItems: "flex-start", m: 0, }}
                        control={<Checkbox checked={agreeContractService} onChange={(e) => setAgreeContractService(e.target.checked)} sx={{ mt: 0.2 }} />}
                        label={
                            <Typography variant="body2" sx={{ lineHeight: 1.7, color: "#444", }} >
                                Li e aceito os termos do{" "}
                                <Link href="/contrato-plano" target="_blank" underline="hover" >
                                    Contrato de Prestação de Serviços
                                </Link>. Declaro estar ciente de que, ao finalizar a contratação, estou aderindo ao plano selecionado e autorizando a cobrança dos valores correspondentes, conforme as condições, prazos e regras estabelecidos no contrato.
                            </Typography>
                        }
                    />
                </Box>
                <Box sx={{ width: "100%", p: 0, }} >
                    <FormControlLabel sx={{ alignItems: "flex-start", m: 0, }}
                        control={<Checkbox checked={agreeConditions} onChange={(e) => setAgreeConditions(e.target.checked)} sx={{ mt: 0.2 }} />}
                        label={
                            <Typography variant="body2" sx={{ lineHeight: 1.7, color: "#444", }} >
                                Li e aceito os{" "}
                                <Link href="/termos-de-uso" target="_blank" underline="hover" >
                                    Termos de Uso
                                </Link>{" "}
                                e a{" "}
                                <Link href="/politica-de-privacidade" target="_blank" underline="hover"
                                >
                                    Política de Privacidade
                                </Link>{" "}
                                da Contblack. Declaro estar ciente das condições de utilização da plataforma, bem como da forma como meus dados pessoais são coletados, utilizados, armazenados e tratados, conforme estabelecido nos respectivos documentos.
                            </Typography>
                        }
                    />
                </Box>
            </div >
        )
    }

    const HandleRegister = async () => {
        setOpen(true);

        const api = axios.create({
            baseURL: process.env.REACT_APP_API_URL
        });

        const dadosCadastro = {
            nome,
            email,
            tipoPessoa: typePerson,
            cpf: TirarMascara(cpf),
            cnpj: TirarMascara(cnpj),
            razaoSocial,
            telefone: TirarMascara(telefone),
            senha,
            cep: TirarMascara(cep),
            estado,
            cidade,
            bairro,
            endereco: logradouro,
            numero,
            complemento
        };

        try {

            const cadastroResponse = await api.post("/cadastro", dadosCadastro);
            if (cadastroResponse.data.status === 200) {
                setOpenSnackbarSuccess(true);
                setMensagem("Usuário cadastrado com sucesso!");

                const loginResponse = await api.post("/login", { email, senha });
                const { token, mensagem, usuario } = loginResponse.data;

                localStorage.setItem("token", token);
                localStorage.setItem("email", usuario.Email);
                fetchLogin();
                navigate("../checkout");

            } else {
                setOpenSnackbarError(true);
                setMensagem("Erro ao cadastrar usuário. Tente novamente.");
                setOpen(false);
            }


        } catch (error) {
            const status = error.response?.status;

            console.error("Erro:", error.response?.data || error.message);

            if (status === 401 || status === 404) {
                setOpenSnackbarError(true);
                setMensagem("E-mail ou senha incorretos ou problema ao gerar contrato.");
                setOpen(false);

            } else {
                setOpen(false);
                setOpenSnackbarError(true);
                setMensagem("Ocorreu um erro inesperado. Tente novamente mais tarde.");
            }
        }
    };

    const handleNextStep = async () => {
        console.log(cep, TirarMascara(cep));

        let isValid = true;

        const isCpfValid = ValidadorCpf(cpf);

        if (currentStep === 1) {
            // =========================
            // ETAPA 1 - DADOS PESSOAIS
            // =========================

            if (!nome.trim()) {
                setNomeError(true);
                isValid = false;
            } else {
                setNomeError(false);
            }

            if (!cpf.trim() || cpf.length < 14) {
                setCpfError(true);
                isValid = false;
            } else {
                setCpfError(false);
            }

            if (isCpfValid === false) {
                setCpfError(true);
                isValid = false;
            } else {
                setCpfError(false);
            }

            // =========================
            // E-MAIL
            // =========================

            if (!email.trim()) {
                setEmailError(true);
                isValid = false;
            } else {
                setEmailError(false);
            }

            const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

            if (!emailRegex.test(email)) {
                setMensagem("E-mail inválido. Tente novamente.");
                setOpenSnackbarError(true);
                setEmailError(true);
                isValid = false;
            }

            if (!isValid) {
                return;
            }

            try {
                // ============================================
                // 1. PRIMEIRO SALVA O LEAD
                // ============================================

                const leadResponse = await salvarLead(currentStep);

                console.log("Lead salvo:", leadResponse);

                // ============================================
                // 2. SÓ ENVIA O CÓDIGO DEPOIS DE SALVAR
                // ============================================

                const emailResponse = await HandleSendEmailVerification(email);

                if (
                    emailResponse?.data?.status === "400" ||
                    emailResponse?.data?.status === 400
                ) {
                    setEmailError(true);

                    setMensagem(
                        emailResponse?.data?.mensagem ||
                        "Não foi possível enviar o código de confirmação."
                    );

                    setOpenSnackbarError(true);

                    return;
                }

                if (
                    emailResponse?.data?.status === "500" ||
                    emailResponse?.data?.status === 500
                ) {
                    setEmailError(true);

                    setMensagem(
                        "Ocorreu um erro ao enviar o código de confirmação."
                    );

                    setOpenSnackbarError(true);

                    return;
                }

                // ============================================
                // 3. LEAD + ENVIO DO CÓDIGO OK
                // ============================================

                setEmailError(false);

            } catch (error) {
                console.error("Erro ao salvar lead/enviar código:", error);

                setMensagem(
                    "Não foi possível continuar. Tente novamente."
                );

                setOpenSnackbarError(true);

                return;
            }
        }

        if (currentStep === 3) {

            if (senha.trim() === "" || senha.length < 6) {
                setSenhaError(true);
                setMensagem("A senha deve ter no mínimo 6 caracteres.");
                setOpenSnackbarError(true);
                return;
            }

            setSenhaError(false);

            if (senhaConfirm.trim() === "") {
                setSenhaConfirmError(true);
                return;
            }

            setSenhaConfirmError(false);

            if (senha !== senhaConfirm) {
                setMensagem("As senhas não coincidem.");
                setOpenSnackbarError(true);
                return;
            }

            if (!agreeConditions) {
                setMensagem(
                    "Você deve concordar com os Termos e Condições para continuar."
                );
                setOpenSnackbarError(true);
                return;
            }

            if (!agreeContractService) {
                setMensagem(
                    "Você deve concordar com o Contrato de Prestação de Serviços para continuar."
                );
                setOpenSnackbarError(true);
                return;
            }
            await salvarLead(currentStep);

            await HandleRegister();
            return;
        }

        // ============================================
        // FACEBOOK PIXEL
        // ============================================

        const isFbqAvailable = typeof window.fbq !== "undefined";

        if (isFbqAvailable) {
            window.fbq("track", "Lead", {
                numberOfClicks: 1
            });
        }

        // ============================================
        // SALVA LEAD NAS DEMAIS ETAPAS
        // ============================================

        if (currentStep !== 1) {
            await salvarLead(currentStep);
        }

        setCurrentStep((prev) => Math.min(prev + 1, 5));

        console.log("Etapa atual:", currentStep);
    };
    const stepsToFollow = [
        {
            number: "01",
            color: "#28E67A",
            title: "Informe seus dados para criar sua conta.",
        },
        {
            number: "02",
            color: "#FF9B3D",
            title: "Escolha a melhor forma para o pagamento.",
        },
        {
            number: "03",
            color: "#5A67F2",
            title: "Pronto! Sua contabilidade na palma da mão.",
        },
    ];


    return (
        <>
            <Header checkout={true} />
            <div style={{
                marginTop: "80px",
                width: "100%",
                padding: "20px",
                minHeight: "100vh",
                boxSizing: "border-box"
            }}>
                <div style={{
                    width: isMobile ? "100%" : "80%",
                    margin: "0 auto",
                }}>
                    <div>
                        <h1>Que bom que você escolheu assinar um plano ContBlack!</h1>
                        <span>Falta pouco para você ter acesso a todos os benefícios de uma contabilidade que entende do digital. Confira os próximos passos.</span>
                    </div>
                    <Box
                        sx={{
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            gap: 2,
                            flexWrap: "wrap",
                            width: "100%",
                            marginTop: 4,
                            marginBottom: 2,
                        }}
                    >
                        {stepsToFollow.map((step, index) => (
                            <Box
                                key={index}
                                sx={{
                                    display: "flex",
                                    alignItems: "center",
                                    width: {
                                        xs: "100%",
                                        md: "auto",
                                    },
                                }}
                            >
                                <Box
                                    sx={{
                                        position: "relative",
                                        width: isMobile ? "100%" : 300,
                                        height: 140,
                                        borderRadius: "16px",
                                        border: `2px solid ${step.color}`,
                                        bgcolor: "#fff",
                                        overflow: "hidden",
                                        p: 3,
                                        display: "flex",
                                        flexDirection: "column",
                                        justifyContent: "center",
                                    }}
                                >
                                    {/* Círculo decorativo */}
                                    <Box
                                        sx={{
                                            position: "absolute",
                                            top: -55,
                                            right: -55,
                                            width: 150,
                                            height: 150,
                                            borderRadius: "50%",
                                            border: `28px solid ${step.color}`,
                                            opacity: 0.75,
                                        }}
                                    />

                                    {/* Número */}
                                    <Box
                                        sx={{
                                            width: 28,
                                            height: 28,
                                            borderRadius: "4px",
                                            bgcolor: step.color,
                                            display: "flex",
                                            alignItems: "center",
                                            justifyContent: "center",
                                            color: "#fff",
                                            fontWeight: 700,
                                            fontSize: 13,
                                            mb: 2,
                                            zIndex: 1,
                                        }}
                                    >
                                        {step.number}
                                    </Box>

                                    {/* Texto */}
                                    <Typography
                                        sx={{
                                            fontSize: "0.9rem",
                                            fontWeight: 500,
                                            lineHeight: 1.2,
                                            maxWidth: 200,
                                            zIndex: 1,
                                        }}
                                    >
                                        {step.title}
                                    </Typography>
                                </Box>

                                {index < stepsToFollow.length - 1 && (
                                    <ChevronRightIcon
                                        sx={{
                                            mx: 1,
                                            fontSize: 38,
                                            color: stepsToFollow[index + 1].color,
                                            display: {
                                                xs: "none",
                                                md: "block",
                                            },
                                        }}
                                    />
                                )}
                            </Box>
                        ))}
                    </Box>
                    <div
                        style={{
                            display: planoSelected ? "flex" : "none",
                            flexDirection: "row",
                            justifyContent: "space-between",
                            alignItems: "center",
                            backgroundColor: "#f9f9f9",
                            border: "1px solid #e0e0e0",
                            borderRadius: "12px",
                            padding: "20px",
                            marginBottom: "20px",
                            boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                            flexWrap: "wrap"
                        }}
                    >

                        <div style={{ display: "flex", flexDirection: "row", alignItems: "center", gap: "15px", flexWrap: "wrap", maxWidth: isMobile ? "100%" : "90%" }}>
                            <div style={{ display: "flex", justifyContent: "center", alignItems: "center", width: isMobile ? "50px" : "60px", height: isMobile ? "50px" : "60px", borderRadius: "50%", backgroundColor: "#f0f0f0" }}>
                                <DiamondIcon style={{ fontSize: isMobile ? "2rem" : "2.5rem", color: "#9C01B9" }} />
                            </div>
                            <div style={{ display: "flex", flexDirection: "column", justifyContent: "center", alignItems: "flex-start", gap: "5px", maxWidth: isMobile ? "calc(100% - 60px)" : "calc(100% - 80px)" }}>
                                <p style={{ margin: "8px 0", fontSize: isMobile ? "1rem" : "1.1rem", fontWeight: "bold", color: "#333" }}>
                                    Plano {planoSelected.title || "Nenhum plano selecionado"}
                                </p>

                                <p style={{ margin: "8px 0", fontSize: isMobile ? "0.95rem" : "1rem", color: "#555", }}>
                                    {planoSelected.description || "Nenhuma descrição disponível"}
                                </p>
                            </div>
                        </div>

                        <div>
                            <p style={{ margin: "8px 0", fontSize: "1rem", color: "#0b243d", fontWeight: "600", display: "flex", flexDirection: "column", justifyContent: "flex-end" }}>
                                <span style={{ fontSize: "1.5rem" }}>{FormatToBrl(planoSelected.price) || "Nenhum valor disponível"}</span>
                                <span style={{ fontSize: "0.7rem" }}>POR MÊS</span>
                            </p>
                        </div>
                    </div>
                </div>
                <div style={{
                    width: isMobile ? "100%" : "80%",
                    margin: "0 auto",
                    padding: isMobile ? "10px" : "20px",
                    backgroundColor: "#f9f9f9",
                    border: "1px solid #e0e0e0",
                    boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
                    borderRadius: "12px"
                }}>


                    <div style={{ width: "100%", padding: "0 10px 10px" }}>
                        <h1>Cadastro</h1>
                    </div>
                    <div style={{
                        display: "flex",
                        flexDirection: isMobile ? "column" : "row",
                        flexWrap: isMobile ? "wrap" : "nowrap",
                        gap: isMobile ? "15px" : "20px",
                        justifyContent: "space-between",
                        alignItems: "center",
                        overflowX: "auto"
                    }}>
                        {steps.map((step, index) => {
                            const active = step.number === currentStep;
                            const completed = step.number < currentStep;

                            return (
                                <React.Fragment key={step.number}>
                                    <div
                                        style={{
                                            display: "flex",
                                            alignItems: "center",
                                            flexShrink: 0,
                                            minWidth: isMobile ? "100%" : "fit-content",
                                            gap: "12px",
                                        }}
                                    >
                                        {/* Número */}
                                        <div
                                            style={{
                                                width: isMobile ? 36 : 48,
                                                height: isMobile ? 36 : 48,
                                                borderRadius: "50%",
                                                display: "flex",
                                                justifyContent: "center",
                                                alignItems: "center",
                                                backgroundColor: completed
                                                    ? "#1EFF86"
                                                    : active
                                                        ? "#1EFF86"
                                                        : "#EAEAEA",
                                                border: active
                                                    ? "3px solid #1EFF86"
                                                    : "2px solid transparent",
                                                color: completed || active ? "black" : "#777",
                                                fontWeight: 700,
                                                fontSize: isMobile ? "0.95rem" : "1.05rem",
                                                transition: "all .25s ease",
                                            }}
                                        >
                                            {step.number}
                                        </div>

                                        {/* Texto */}
                                        <div>
                                            <p
                                                style={{
                                                    margin: 0,
                                                    fontSize: isMobile ? ".9rem" : "1rem",
                                                    fontWeight: active ? 700 : 500,
                                                    color: active ? "#111" : "#666",
                                                    transition: ".2s",
                                                }}
                                            >
                                                {step.label}
                                            </p>
                                        </div>
                                    </div>

                                    {/* Linha */}
                                    {index < steps.length - 1 && (
                                        <div
                                            style={{
                                                flex: 1,
                                                height: 3,
                                                borderRadius: 20,
                                                backgroundColor:
                                                    completed || currentStep > step.number
                                                        ? "#1EFF86"
                                                        : "#E5E5E5",
                                                transition: "background-color .3s ease",
                                            }}
                                        />
                                    )}
                                </React.Fragment>
                            );
                        })}
                    </div>
                    {currentStep === 1
                        ? stepOne()
                        : currentStep === 2
                            ? StepTwo()
                            : currentStep === 3
                            && stepThree()}


                    <div style={{
                        marginTop: "20px",
                        display: "flex",
                        justifyContent: currentStep === 1 ? "flex-end" : "space-between",
                    }}>
                        <Button
                            onClick={() => setCurrentStep((prev) => Math.max(prev - 1, 1))}
                            variant="contained"
                            sx={{
                                padding: "5px 28px",
                                width: "100px",
                                display: currentStep === 1 ? "none" : "flex",
                                backgroundColor: "#9C01B9",
                                borderRadius: "17px 0 17px 0",
                                fontSize: "0.7rem",
                                color: "white",
                                fontWeight: 800,
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#1EFF86",
                                    boxShadow: "0 4px 10px #1EFF86",

                                }
                            }}
                        >Voltar</Button>
                        <Button onClick={handleNextStep}
                            sx={{
                                padding: "5px 28px",
                                width: "100px",
                                backgroundColor: "#9C01B9",
                                borderRadius: "17px 0 17px 0",
                                fontSize: "0.7rem",
                                color: "white",
                                display: currentStep === 2 ? "none" : "flex",
                                fontWeight: 800,
                                transition: "0.3s ease",
                                '&:hover': {
                                    backgroundColor: "#1EFF86",
                                    boxShadow: "0 4px 10px #1EFF86",

                                }
                            }}>
                            {currentStep === 3 ? "Finalizar" : "Próximo"}
                        </Button>
                    </div>
                </div>
                <div style={{ width: "100%", display: "flex", justifyContent: "center", marginTop: "50px", }} >
                    <div style={{ display: "flex", alignItems: "center", gap: "16px", padding: "14px 20px", borderRadius: "16px", cursor: "pointer", transition: "0.2s ease", }} onClick={() => window.open(gerarLinkWhatsApp("Olá, estou com dúvidas para adquirir o plano."))} >
                        <div style={{ width: "52px", height: "52px", borderRadius: "50%", backgroundColor: "#1EFF86", display: "flex", justifyContent: "center", alignItems: "center", flexShrink: 0, }} >
                            <WhatsAppIcon sx={{ fontSize: 28, color: "#000", }} />
                        </div>
                        <div>
                            <p style={{ margin: 0, fontWeight: 700, fontSize: "1rem", color: "#111", }} >
                                Tem alguma dúvida?
                            </p>
                            <span style={{ display: "block", marginTop: "4px", fontSize: "0.9rem", color: "#666", }} >
                                Fale com um consultor ➔
                            </span>
                            <div style={{ width: "100%", height: "3px", backgroundColor: "#1EFF86", borderRadius: "10px", marginTop: "10px", }} />
                        </div>
                    </div>
                </div>
            </div >
            <footer style={{ backgroundColor: "#233344", padding: "10px 0", display: "flex", justifyContent: "center" }} >
                <div style={{ color: "white", fontSize: "0.8rem", textAlign: "center", width: "80%", display: "flex", justifyContent: "space-between", alignItems: "center", flexDirection: isMobile ? "column" : "row", gap: isMobile ? "10px" : 0 }}>
                    <div>
                        <img src="../assets/Logo_Contblack_FundoEscuro.png" alt="Logo" style={{ width: "130px", margin: "20px auto", display: "block" }} />
                    </div>
                    <div>
                        <p style={{ textAlign: "center", color: "white", fontSize: "0.9rem" }}>
                            &copy; {new Date().getFullYear()} Contblack. Todos os direitos reservados.
                        </p>
                    </div>
                    <div style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "4px", border: "1px solid #1EFF86", padding: "2px 2px", borderRadius: "20px", userSelect: "none" }}>
                        <div style={{ display: "flex", alignItems: "center", justifyContent: "center", borderRadius: "50%", width: "25px", height: "25px", backgroundColor: "#1EFF86" }}>
                            <GppGoodIcon sx={{ color: "#005ac2", fontSize: "1.3rem" }} />
                        </div>
                        <span style={{ color: "#1EFF86", fontSize: "0.8rem" }}>SITE 100% SEGURO</span>
                    </div>
                </div>
            </footer>
            <AlertSuccess openSnackbarSuccess={openSnackbarSuccess} setOpenSnackbarSuccess={setOpenSnackbarSuccess} mensagem={mensagem} />
            <AlertError openSnackbarError={openSnackbarError} setOpenSnackbarError={setOpenSnackbarError} mensagem={mensagem} />
            <Loading open={open} />
        </>
    );
}

export default Register;
